import React, {Component} from 'react'
import FilterDateRangeV2 from '../filters/FilterDateRangeV2'
import {Button, Popover} from 'antd'
import PropTypes from 'prop-types'

class OrdersDateFilter extends Component {
    _dateKeys = ['created_at', 'approved_at', 'uploaded_at', 'mark_printed_at', 'first_pushed_at']

    _renderDateFilterContent = () => {
        return (
            <div>
                <FilterDateRangeV2 {...this.props} heading='Ngày tạo:' field='created_at' className='mb-3'/>
                <FilterDateRangeV2 {...this.props} heading='Ngày duyệt:' field='approved_at' className='mb-3'/>
                <FilterDateRangeV2 {...this.props} heading='Ngày upload:' field='uploaded_at' className='mb-3'/>
                <FilterDateRangeV2 {...this.props} heading='Ngày đánh dấu đã in:' field='mark_printed_at' className='mb-3'/>
                <FilterDateRangeV2 {...this.props} heading='Ngày đẩy vào lô:' field='first_pushed_at' className='mb-3'/>
            </div>
        )
    }

    _detectDateFiltered = () => {
        const {filters} = this.props

        return this._dateKeys.some(key => {
            if (!filters.hasOwnProperty(key)) {
                return false
            }

            const {from, to} = filters[key]

            return !!from || !!to
        })
    }

    render() {
        const popoverContent = this._renderDateFilterContent()
        const dateFiltered = this._detectDateFiltered()

        return (
            <div className='OrdersDateFilter'>
                <Popover placement='bottom' content={popoverContent} trigger='click'>
                    {
                        dateFiltered
                            ?
                            <Button type='primary' ghost>Lọc theo ngày</Button>
                            :
                            <Button>Lọc theo ngày</Button>
                    }

                </Popover>
            </div>
        )
    }
}

OrdersDateFilter.propTypes = {
    filters: PropTypes.object.isRequired,
    onDatesChange: PropTypes.func.isRequired,
}

export default OrdersDateFilter
